"use client";
import React from "react";
import "./clents.css"
import { companies, testimonials } from "../data/index";
import { InfiniteMovingCards } from "../ui/InfiniteMovingCards";
import AliceCaru from "./AliceCaru";

const Clients = ({testimonialsRef}) => {
  return (
    <section id="testimonials" className="testimonials-section">
      <h1 className="heading" ref={testimonialsRef} >
        Kind words from
        <span className="highlight"> satisfied clients</span>
      </h1>

      <div className="testimonials-container">
        
        <AliceCaru/>
                   
          {/*
           <div className="testimonials-slider">
                      <InfiniteMovingCards
              items={testimonials}
              direction="right"
              speed="slow"
          />
           </div>

         */}
        

        <div className="companies-list">
          {companies.map((company) => (
            <React.Fragment key={company.id}>
              <div className="company-item">
                <img
                  src={company.img}
                  alt={company.name}
                  className="company-logo"
                />
                <img
                  src={company.nameImg}
                  alt={company.name}
                  width={company.id === 4 || company.id === 5 ? 100 : 150}
                  className="company-name-img"
                />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
